module.exports = __webpack_public_path__ + "b275d2ffa531a0cdf4ccc43994f68ff6.png";